// extracted by mini-css-extract-plugin
module.exports = {"sCentersMainConatiner":"ServiceCentersComponent-module__sCentersMainConatiner","mainImageClass":"ServiceCentersComponent-module__mainImageClass"};